import { createAction } from '@reduxjs/toolkit';

import type { LocationChangePayload } from './types';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

// Both type parameters are required: with only the payload parameter given,
// the action type widens to string and breaks RootAction narrowing.
export const locationChange = createAction<
  LocationChangePayload,
  typeof LOCATION_CHANGE
>(LOCATION_CHANGE);
